<template>
  <div class="concerned">
    <div class="additionbtn">
      <el-button size="mini" icon="el-icon-plus" @click="addition = true" >添加</el-button>
    </div>
    <div class="timebox">
      <el-radio-group @change="timetypechange" v-model="timetype" size="mini">
        <el-radio-button label="day">日</el-radio-button>
        <el-radio-button label="month">月</el-radio-button>
        <el-radio-button label="year">年</el-radio-button>
      </el-radio-group>
      <el-date-picker
        style="margin-left: 15px;position: relative;top: 2px;"
        v-model="time"
        :type="datetype"
        range-separator="至"
        start-placeholder="开始日期"
        size="mini"
        @change="timechange"
        end-placeholder="结束日期">
      </el-date-picker>
      <div class="delete"><el-button size="mini" @click="alldelete = true" >批量删除</el-button></div>
    </div>
    <div class="wire" />
    <div class="meetingcont">
      <div class="meetingbox" @click="getparticulars(item.gid)" v-for="item in concernedlistdata" :key="item.gid">
        <div class="meetingHeadline">{{item.title}}</div>
        <div class="meetingtext">{{item.content}}</div>
        <div class="wire" style="margin-top: 15px" />
        <div class="message">
          <div class="messagetext">发布人：<span class="value">{{item.username}}</span></div>
          <div class="messagetext">发起时间：<span class="value">{{item.releasetime}}</span></div>
          <!-- <div><i class="el-icon-alarm-clock imgtip" /></div> -->
        </div>
      </div>
      <div style="clear:both" />
    </div>

    <el-dialog
      title="紧急事宜详情"
      :visible.sync="particulars"
      width="700px"
      >
      <div class="describe"><span class="title">紧急事宜标题：</span><span class="value">{{particularsdata.title}}</span></div>
      <div class="describe"><span class="title">紧急事宜内容：</span><span class="value" style="color: #38455A">{{particularsdata.content}}</span></div>
      <div class="describe"><span class="title">发起人：</span><span class="value">{{particularsdata.username}}</span></div>
      <div class="describe"><span class="title">通知人员：</span><span class="value">{{particularsdata.depts}}</span></div>
      <div class="wire" style="margin-top: 35px;margin-bottom: 15px" />
      <div style="margin: auto;text-align: center;">
        <el-button @click="affirm(particularsdata.gid)" type="danger" size="small" style="width: 250px;">删除</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="紧急事宜发布"
      :visible.sync="addition"
      width="700px"
      >
      <div class="cont" style="margin-top: 0px;">
        <div class="title">紧急事宜标题：</div>
        <div class="value">
          <el-input
            type="text"
            placeholder="填写事宜标题"
            v-model="title"
            maxlength="39"
            size="small"
            show-word-limit
            @change="titleChange"
          >
          </el-input>
        </div>
      </div>

      <div class="cont">
        <div class="title">紧急事宜内容：</div>
        <div class="value">
          <el-input
            type="textarea"
            :autosize="{ minRows: 8, maxRows: 8}"
            placeholder="填写内容详情"
            v-model="details"
            maxlength="199"
            show-word-limit
            @change="detailsChange"
            resize="none"
          >
          </el-input>
        </div>
      </div>

      <div class="cont">
        <div class="title">参会人员：</div>
        <div class="value">
          <div class="personnel">
            <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
              <el-checkbox v-for="item in cities" :label="item.name" :key="item.name">{{item.name}}</el-checkbox>
            </el-checkbox-group>
            <div class="allbtn">
              <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全部</el-checkbox>
            </div>
          </div>
        </div>
      </div>

      <div class="wire" style="margin-top: 35px;margin-bottom: 15px" />
      <div style="margin: auto;text-align: center;">
        <el-button type="primary" size="small" style="width: 250px;" @click="open">确认</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="删除"
      :visible.sync="alldelete"
      width="400px"
      >
      <div class="deletebox">
        <el-checkbox :indeterminate="deleteminate" v-model="deleteAll" @change="deleteAllChange">全部</el-checkbox>
        <div class="checkbox">
          <el-checkbox-group v-model="deletedata" @change="deleteChange">
            <div class="checklist" v-for="item in concernedlistdata" :key="item.gid" >
              <el-checkbox :label="item.gid" :key="item.gid"><span>{{item.title}}</span></el-checkbox>
            </div>
          </el-checkbox-group>
        </div>
        <div class="wire" />
        <div @click="alldeletenopen" class="ackButton">
          删除
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { mapState } from "vuex";
import { APIMAP } from "@/constants/apiConstants";
import { getServerData } from "@/utils/fetchData";
import { getFormatDate } from "@/utils/util";
export default {
  data() {
    const starttime = getFormatDate().substring(0, 10) + " 00:00:00";
    const endtime = getFormatDate().substring(0, 10) + " 23:59:59";
    return {
      readdata: "",
      cities: "",
      isIndeterminate: false,
      deleteminate: false,
      checkedCities: [],
      deletelist: [],
      deletedata: [],
      checkAll: false,
      deleteAll: false,
      timetype: "day",
      datetype: "datetimerange",
      particulars: false,
      addition: false,
      alldelete: false,
      title: "",
      details: "",
      concernedlistdata: [],
      particularsdata: [],
      time: [this.formatting(starttime), this.formatting(endtime)],
      starttime,
      endtime
    };
  },
  computed: {
    ...mapState(["userInfo"])
  },
  mounted() {
    this.concernedlist();
    this.getselectdata();
  },
  methods: {
    async getselectdata() {
      const readres = await getServerData(
        APIMAP.GET_DEPARTMENT,
        {
          pid: this.userInfo.platformid,
          // type: "1"
        },
        "get"
      );
      console.log("列表", readres);
      this.cities = readres;
      this.readdata = readres;
      console.log(this.sitedata);
    },
    handleCheckedCitiesChange(value) {
      console.log(value);
      const checkedCount = value.length;
      this.checkAll = checkedCount === this.cities.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.cities.length;
    },
    handleCheckAllChange(val) {
      var allname = [];
      this.readdata.forEach(item => {
        allname.push(item.name);
      });
      this.checkedCities = val ? allname : [];
      this.isIndeterminate = false;
    },
    deleteChange(value) {
      console.log(value);
      const checkedCount = value.length;
      this.deleteAll = checkedCount === this.concernedlistdata.length;
      this.deleteminate =
        checkedCount > 0 && checkedCount < this.concernedlistdata.length;
    },
    deleteAllChange(value) {
      this.deletedata = value ? this.deletelist : [];
      this.deleteminate = false;
    },
    titleChange(e) {
      this.title = e;
      console.log(e);
    },
    detailsChange(e) {
      this.details = e;
    },
    formatting(time) {
      const date = new Date(time).getTime();
      console.log(date);
      return date;
    },
    timetypechange(e) {
      console.log(e);
      let starttime;
      let endtime;
      if (e === "day") {
        starttime = getFormatDate().substring(0, 10) + " 00:00:00";
        endtime = getFormatDate();
        this.datetype = "datetimerange";
      } else if (e === "month") {
        starttime = getFormatDate().substring(0, 8) + "01";
        endtime = getFormatDate().substring(0, 10);
        this.datetype = "daterange";
      } else {
        starttime = getFormatDate().substring(0, 5) + "01-01";
        endtime = getFormatDate().substring(0, 10);
        this.datetype = "daterange";
      }
      console.log(starttime, endtime);
      this.timetype = e;
      this.starttime = starttime;
      this.endtime = endtime;
      this.time = [this.formatting(starttime), this.formatting(endtime)];
      this.concernedlist();
    },
    timechange(e) {
      console.log(e);
      this.starttime = getFormatDate(e[0]);
      this.endtime = getFormatDate(e[1]);
      console.log(this.starttime, this.endtime);
      this.time = [this.formatting(e[0]), this.formatting(e[1])];
      this.concernedlist();
      // const hour = getFormatDate(new Date(this.hour)).substring(10, 19);
      // this.starttime = getFormatDate(e).substring(0, 10) + hour;
      // console.log(this.starttime);
    },
    open() {
      this.$confirm("是否提交?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.UpLoad();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    async UpLoad() {
      let depts = "";
      if (this.checkedCities.length > 0) {
        this.checkedCities.forEach((item, i) => {
          if (this.checkedCities.length - 1 === i) {
            depts += item;
          } else {
            depts += item + ",";
          }
        });
      }
      console.log("1232343456", depts);
      try {
        const param = {
          title: this.title,
          content: this.details,
          depts: depts,
          type: "2",
          username: this.userInfo.realname,
          pid: this.userInfo.platformid,
          uid: this.userInfo.gid
        };
        console.log(param);
        const res = await getServerData(APIMAP.WORKING, param, "post");
        console.log("紧急", res);
        this.$message({
          type: "success",
          message: "提交成功!"
        });
        this.isIndeterminate = false;
        this.addition = false;
        this.title = "";
        this.details = "";
        this.depts = [];
        this.checkedCities = [];
        this.checkAll = false;
        this.concernedlist();
      } catch (e) {
        this.$message.error("提交失败");
      }
    },
    async concernedlist() {
      try {
        const res = await getServerData(
          APIMAP.WORKING,
          {
            pid: this.userInfo.platformid,
            size: 100000,
            type: "2",
            startTime: this.starttime,
            endTime: this.endtime
          },
          "get"
        );
        console.log("列表", res);
        const data = res.rows;
        data.forEach(item => {
          this.deletelist.push(item.gid);
        });
        console.log(this.deletelist);
        this.concernedlistdata = data;
      } catch (e) {
        console.log(e);
      }
    },
    async getparticulars(gid) {
      console.log(APIMAP.MEETING + `/:${gid}`);
      try {
        const res = await getServerData(
          APIMAP.WORKING + `/${gid}`,
          {
            gid: gid
          },
          "get"
        );
        console.log("详情", res);
        this.particulars = true;
        this.particularsdata = res;
      } catch (e) {
        console.log(e);
      }
    },
    affirm(gid) {
      this.$confirm("是否删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.remove(gid);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    alldeletenopen() {
      this.$confirm("是否删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.remove();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    async remove(gid) {
      console.log(gid);
      let gids = "";
      if (!gid) {
        this.deletedata.forEach((item, i) => {
          if (this.deletedata.length - 1 === i) {
            gids += item;
          } else {
            gids += item + ",";
          }
        });
      } else {
        gids = gid;
      }
      console.log(gids);
      try {
        const res = await getServerData(
          APIMAP.WORKING,
          {
            gids: gids
          },
          "DELETE"
        );
        console.log("1", res);
        this.particulars = false;
        this.alldelete = false;
        this.concernedlist();
      } catch (e) {
        console.log(e);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.concerned {
  .additionbtn {
    position: absolute;
    right: 0px;
    top: -60px;
  }
  .timebox {
    margin-top: 20px;
    margin-bottom: 10px;
    .delete {
      float: right;
    }
  }
  .wire {
    margin-top: 10px;
    border: 1px solid rgba(226, 229, 236, 0.6);
  }
  .meetingcont {
    border: 1px solid #e2e5ec;
    margin-top: 15px;
    border-radius: 2px;
    position: relative;
    height: calc(100vh - 310px);
    overflow: auto;
    .historybtn {
      font-size: 12px;
      font-family: PingFangSC, PingFangSC-Regular;
      color: #99a9ba;
      position: absolute;
      right: 0px;
      top: -25px;
      cursor: pointer;
    }
    .meetingbox {
      width: calc(33.3% - 40px);
      // max-width: 380px;
      // min-width: 330px;
      // width: 380px;
      // margin-right: 120px;
      float: left;
      padding: 20px;
      overflow: hidden;
      margin-bottom: 5px;
      position: relative;
      // margin-right: 120px;
      .meetingHeadline {
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-family: PingFangSC, PingFangSC-Medium;
        font-size: 14px;
        font-weight: 900;
        color: #2c3a50;
        letter-spacing: 2px;
      }
      .meetingtext {
        margin-top: 12px;
        font-size: 12px;
        font-family: PingFangSC, PingFangSC-Regular;
        color: #969aa5;
        letter-spacing: 1px;
        height: 35px;

        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        // position: relative;
        // line-height: 20px;
        // max-height: 40px;
        // overflow: hidden;
      }
      // .meetingtext::after {
      //   content: "...";
      //   position: absolute;
      //   bottom: 0;
      //   right: 0;
      //   padding-left: 40px;
      //   background: -webkit-linear-gradient(left, transparent, #fff 55%);
      //   background: -o-linear-gradient(right, transparent, #fff 55%);
      //   background: -moz-linear-gradient(right, transparent, #fff 55%);
      //   background: linear-gradient(to right, transparent, #fff 55%);
      // }
      .message {
        margin-top: 15px;
        display: flex;
        justify-content: space-between;
        .messagetext {
          color: #969aa5;
        }
        .value {
          color: #38455a;
          margin-left: 10px;
        }
        .imgtip {
          color: #ffb431;
          font-size: 14px;
        }
      }
    }
  }
  .describe {
    overflow: hidden;
    margin-bottom: 15px;
    font-size: 14px;
    .title {
      color: #969aa5;
      float: left;
      width: 100px;
    }
    .value {
      color: #38455a;
      margin-left: 15px;
      float: left;
      width: calc(100% - 115px);
      letter-spacing: 1px;
    }
    .clear {
      margin: auto;
    }
  }
  .cont {
    overflow: hidden;
    margin-top: 25px;
    font-size: 14px;
    .title {
      float: left;
      width: 100px;
      margin-right: 10px;
      position: relative;
      color: #394259;
      top: 6px;
    }
    .value {
      float: left;
      width: calc(100% - 115px);
      .personnel {
        padding: 15px 10px;
        height: 83px;
        border: 1px solid rgba(201, 209, 212, 0.7);
        border-radius: 4px;
        position: relative;
        overflow: auto;
        .allbtn {
          position: absolute;
          right: 15px;
          bottom: 10px;
        }
      }
    }
  }
  .deletebox {
    .tipbox {
      overflow: hidden;
      .DownloadTip {
        float: left;
        margin-left: 35px;
      }
    }
    .Memberkbox {
      margin-top: 10px;
      border: 1px solid #edeef3;
      border-radius: 3px;
      border-bottom: 0px;
    }
    .checkbox {
      background: #f5f6fd;
      margin-top: 10px;
      height: 300px;
      overflow: auto;
      .checklist {
        padding: 11px 13px;
        border-bottom: 1px dashed #e2e5ec;
        span {
          display: inline-block;
          width: 300px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          position: relative;
          top: 4px;
        }
      }
    }
    .wire {
      margin-top: 26px;
      border: 1px solid rgba(226, 229, 236, 0.6);
    }
    .ackButton {
      width: 300px;
      height: 30px;
      border: 1px solid #f56c6c;
      border-radius: 4px;
      background: #f56c6c;
      text-align: center;
      line-height: 30px;
      letter-spacing: 2px;
      color: white;
      margin: auto;
      margin-top: 15px;
      cursor: pointer;
    }
  }
}
</style>
